import { el, onTap } from '../ui/dom.ts';
import { navigate, setPageMeta } from '../router.ts';
import { BRAND } from '../ui/brand.ts';
import { paperPage } from '../ui/paper.ts';
import { errorNote, okNote } from '../ui/feedback.ts';
import { t } from '../i18n/index.ts';
import { legalContent, LEGAL_TABS, type LegalParagraph, type LegalTab } from '../i18n/legal.ts';

// Herkese açık sayfalar: yasal metinler ve uyumluluk. İkisi de açık zeminli
// sayfa düzeninde (landing üst çubuğu + alt bilgi) çizilir; uygulama kabuğu yok.
//
// Yasal metinler `src/web/i18n/legal-tr.ts` ve `legal-en.ts` içinde veri olarak
// durur; bu dosya yalnızca çizer. Her madde kodda gerçekten olan bir davranışı
// anlatır — ürün davranışı değişirse metin de değişmelidir.

function paragraph(item: LegalParagraph): HTMLElement {
  if (typeof item === 'string') return el('p', {}, item.replaceAll('{brand}', BRAND.title));
  if ('list' in item) return el('ul', { class: 'legal-list' }, ...item.list.map((line) => el('li', {}, line)));
  return el('p', { class: 'legal-contact' }, item.contact);
}

export function termsView(_params: Record<string, string>, query: URLSearchParams): void {
  const content = legalContent();
  const requested = query.get('section') as LegalTab | null;
  const tab: LegalTab = requested && LEGAL_TABS.includes(requested) ? requested : 'terms';
  const section = content.sections.find((s) => s.key === tab) ?? content.sections[0];

  const tabs = el('div', { class: 'subnav scroll-x' }, ...content.sections.map((item) => {
    const button = el('button', { type: 'button', class: item.key === tab ? 'active' : '' }, item.label);
    onTap(button, () => navigate(`/legal?section=${item.key}`));
    return button;
  }));

  const body = el('div', {}, ...section.blocks.map((block) =>
    el('section', { class: 'legal-block' },
      el('h2', {}, block.title),
      ...block.body.map(paragraph),
    )));

  // Her bölüm kendi başlığını ve canonical'ını taşır; hepsi "ana sayfa" diye
  // işaretlendiğinde sitemap işlevsiz kalıyordu.
  setPageMeta({
    title: section.label,
    index: true,
    canonical: `${location.origin}/legal?section=${tab}`,
  });

  paperPage(
    // Metin her değiştiğinde `updated` tarihi de değişmeli (sayfa bunu vaat ediyor).
    el('div', { class: 'page-intro' },
      el('div', {}, el('h1', {}, content.title), el('div', { class: 'sub' }, content.updated)),
    ),
    tabs,
    el('div', { class: 'legal' }, body,
      el('p', { class: 'legal-note' }, content.note),
    ),
  );
}

function infoRow(label: string, value: string): HTMLElement {
  return el('div', { class: 'row' },
    el('div', { class: 'grow' }, el('b', {}, label), el('div', { class: 'meta' }, value)),
  );
}

/** Uyumluluk: hangi cihazlarda ne ölçüldü. Rozet/garanti değil, gerçek durum. */
export function compatibilityView(): void {
  setPageMeta({ title: t('meta.compat'), index: true, canonical: location.origin + '/compatibility' });
  const supported = 'VideoDecoder' in window;
  paperPage(
    el('div', { class: 'page-intro' }, el('div', {}, el('h1', {}, t('compat.title')))),
    el('div', { class: 'settings' },
      el('section', {},
        supported ? okNote(t('compat.ok')) : errorNote(t('compat.bad')),
        el('p', { class: 'lead', style: { marginTop: '18px' } }, t('compat.lead')),
        el('div', { class: 'rows' },
          infoRow(t('landing.device.pc'), t('compat.pc')),
          infoRow(t('landing.device.phone'), t('compat.phone')),
          infoRow(t('device.car'), t('compat.car')),
          infoRow(t('landing.device.tablet'), t('compat.tablet')),
          infoRow(t('landing.device.tv'), t('compat.tv')),
        ),
        el('p', { class: 'lead', style: { marginTop: '18px' } }, t('compat.foot')),
      ),
    ),
  );
}
